import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectMediaWidth } from '../../store/slices/media-query.slice';

interface ViewSizeType {
    isXSmall: boolean;
    isSmall: boolean;
    isMedium: boolean;
    isLarge: boolean;
    isXLarge: boolean;
    isXXL: boolean;
    isHD: boolean;
    isUltraWide: boolean;

    /**
     * [0, 640)
     */
    isMaxWidthSmall: boolean;

    /**
     * [0, 768)
     */
    isMaxWidthMedium: boolean;

    /**
     * [0, 992)
     */
    isMaxWidthLarge: boolean;

    /**
     * [0, 1200)
     */
    isMaxWidthXLarge: boolean;

    /**
     * [0, 1440)
     */
    isMaxWidthXXL: boolean;

    /**
     * [0, 1800)
     */
    isMaxWidthHD: boolean;
}

const XS = 375;
const SM = 640;
export const MD = 768;
const LG = 992;
const XL = 1200;
const XXL = 1440;
const HD = 1800;

export const useResizeListener = (onResize?: (innerWidth: number) => void): ViewSizeType => {
    const mediaWidth = useSelector(selectMediaWidth);

    return useMemo(() => {
        onResize?.(mediaWidth);
        return {
            isXSmall: mediaWidth <= XS,
            isSmall: mediaWidth > XS && mediaWidth <= SM,
            isMedium: mediaWidth > SM && mediaWidth <= MD,
            isLarge: mediaWidth > MD && mediaWidth <= LG,
            isXLarge: mediaWidth > LG && mediaWidth <= XL,
            isXXL: mediaWidth > XL && mediaWidth <= XXL,
            isHD: mediaWidth > XXL && mediaWidth <= HD,
            isUltraWide: mediaWidth > HD,

            isMaxWidthSmall: mediaWidth <= SM,
            isMaxWidthMedium: mediaWidth <= MD,
            isMaxWidthLarge: mediaWidth <= LG,
            isMaxWidthXLarge: mediaWidth <= XL,
            isMaxWidthXXL: mediaWidth <= XXL,
            isMaxWidthHD: mediaWidth <= HD,
        };
    }, [mediaWidth]);
};
